import { ContextMenuItemView, EventContextMenuClickParams } from '@mark43/cad-api';
import { useDrawerControls } from '../drawers/components/drawer-context-provider';
import { ContextMenuItem } from '../context-menus/components/context-menu-item';

export function ManageUnitsItem({
    contextMenuItemView,
    clickParams,
}: {
    contextMenuItemView: ContextMenuItemView;
    clickParams: EventContextMenuClickParams;
}): React.ReactElement {
    const drawerControls = useDrawerControls();
    const handleSelect = (): void => {
        drawerControls.open({
            type: 'manage-units',
            props: { eventId: clickParams.eventId },
        });
    };

    return (
        <ContextMenuItem
            dataTrackId="menu-item-manage-units"
            contextMenuItemView={contextMenuItemView}
            onSelect={handleSelect}
        />
    );
}
